import React, { useState } from 'react';
import DOMPurify from 'dompurify';
import './ScrollingText.scss';

interface ScrollingTextProps {
  backgroundColor?: string;
  borderColor?: string;
  textColor?: string;
  scrollingSpeed?: string;
  scrollCount?: number;
  children: string; // HTML content as a string
  display?: boolean;
}

const ScrollingText: React.FC<ScrollingTextProps> = ({
  backgroundColor = 'defaultColor',
  borderColor = 'defaultColor',
  textColor = 'defaultColor',
  scrollingSpeed = '7s',
  scrollCount = 1,
  children,
  display = true,
}) => {
  const [isVisible, setIsVisible] = useState(display);

  // Sanitize HTML content using DOMPurify
  const sanitizedContent = DOMPurify.sanitize(children);

  if (!isVisible) return null;

  return (
    <div
      className="scrolling-text-container"
      style={{
        '--background-color': backgroundColor,
        '--border-color': borderColor,
        '--text-color': textColor,
        '--scroll-speed': scrollingSpeed,
        '--scroll-count': scrollCount,
      } as React.CSSProperties} // Dynamically applying CSS variables
    >
      <div
        className="scrolling-text" 
        dangerouslySetInnerHTML={{ __html: sanitizedContent }} // Safely rendering HTML
      />
      <button className="dismiss-button" onClick={() => setIsVisible(false)}>
        Dismiss
      </button>
    </div>
  );
};

export default ScrollingText;
